import React, { useState, useEffect } from 'react'
import { Box, Button, CircularProgress, Collapse, Dialog, Grid, Typography } from '@material-ui/core'
import styled from 'styled-components'
import SmartInputs from '../../../components/smartInputs/group'
import { getConfig, updateConfig } from '../../../modules/appointment'
import { KeyboardTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import format from 'date-fns/format'
import frLocale from 'date-fns/locale/es'
import { bool, func } from 'prop-types'
import useObjectState from '../../../hooks/useObjectState'
import { Alert } from '@material-ui/lab'

class LocalizedUtils extends DateFnsUtils {
  getDatePickerHeaderText (date) {
    return format(date, 'd MMM yyyy', { locale: this.locale })
  }
}

const Body = styled.div`
  max-width: 500px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 1px;
  min-height: 300px;
  width: 80vw;
  margin: auto;
`

const InputsCOntainer = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 80px 20px;
  @media screen and (max-width:600px) {
    padding: 40px 10px;
  }
`

const Config = props => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useObjectState({ init: null, interval: null, end: null, saturdayInit: null, saturdayEnd: null })
  const [error, setError] = useState(null)

  useEffect(() => {
    setError(false)
  }, [data.interval])

  const fetcher = async () => {
    setLoading(true)
    const config = await getConfig()
    setData(config)
    setLoading(false)
  }

  // fetch initial config
  useEffect(() => { fetcher() }, [])

  const handleInititChange = val => {
    setData({ init: val })
  }

  const handleEndChange = val => {
    setData({ end: val })
  }

  const handleSaturdayInititChange = val => {
    setData({ saturdayInit: val })
  }

  const handleSaturdayEndChange = val => {
    setData({ saturdayEnd: val })
  }

  const handleUpdate = async () => {
    if (parseInt(data.interval) > 0 && parseInt(data.interval) < 61) {
      setLoading(true)
      await updateConfig(data)
      await new Promise(resolve => setTimeout(resolve, 1000))
      props.onClose()
      await new Promise(resolve => setTimeout(resolve, 500))
      fetcher()
      setLoading(false)
    } else {
      setError(true)
    }
  }

  return (
    <Dialog open={props.open}>
      <MuiPickersUtilsProvider utils={LocalizedUtils} locale={frLocale}>
        <Body>

          {!loading && (
            <InputsCOntainer>
              <Collapse in={error}>
                <Box mb={2} item xs={12}>
                  <Alert severity='error'> Intervalo no valido </Alert>
                </Box>
              </Collapse>
              <Grid container spacing={1} justify='center'>

                <Grid item xs={12} sm={8}>
                  <Typography color='primary'>Intervalo de tiempo (minutos)</Typography>
                  <SmartInputs limit={3} filter='number' state={data} setState={setData} name='interval' placeholder='minutos' />
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography color='primary'>Hora de inicio entre semana</Typography>
                  <KeyboardTimePicker ampm InputProps={{ disabled: true }} fullWidth size='small' limit={3} inputVariant='outlined' value={data.init} onChange={handleInititChange} />
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography color='primary'>Hora de finalización entre semana</Typography>
                  <KeyboardTimePicker ampm InputProps={{ disabled: true }} fullWidth size='small' inputVariant='outlined' limit={3} value={data.end} onChange={handleEndChange} />
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography color='primary'>Hora de inicio sábado</Typography>
                  <KeyboardTimePicker ampm InputProps={{ disabled: true }} fullWidth size='small' limit={3} inputVariant='outlined' value={data.saturdayInit} onChange={handleSaturdayInititChange} />
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography color='primary'>Hora de finalización sábado</Typography>
                  <KeyboardTimePicker ampm InputProps={{ disabled: true }} fullWidth size='small' inputVariant='outlined' limit={3} value={data.saturdayEnd} onChange={handleSaturdayEndChange} />
                </Grid>
                <Grid xs={12} sm={8} container justify='center' spacing={2}>
                  <Grid item xs={12} />
                  <Grid item xs={6}>
                    <Button style={{ fontSize: '.8em', marginRight: '1em' }} fullWidth color='primary' variant='outlined' onClick={props.onClose}>Cancelar</Button>
                  </Grid>
                  <Grid item xs={6}>
                    <Button style={{ fontSize: '.8em' }} fullWidth color='primary' variant='contained' onClick={handleUpdate}>Guardar</Button>
                  </Grid>
                </Grid>
              </Grid>

            </InputsCOntainer>
          )}
          {loading && (
            <CircularProgress color='primary/' />
          )}

        </Body>
      </MuiPickersUtilsProvider>
    </Dialog>
  )
}

Config.propTypes = {
  open: bool,
  onClose: func
}

export default Config
